import React from 'react';

const Process = () => {
  return (
    <div className="container-xxl py-5" id="process">
      <div className="container">
        <div className="text-center pb-4 wow fadeInUp" data-wow-delay="0.1s">
          <h6 className="section-title bg-white text-center text-primary px-3">
            Process
          </h6>
          <h1 className="mb-5">3 Easy Steps</h1>
        </div>
        <div className="row gy-5 gx-4 justify-content-center">
          {/* Step 1 */}
          <div
            className="col-lg-4 col-sm-6 text-center pt-4 wow fadeInUp"
            data-wow-delay="0.1s"
          >
            <div className="position-relative border border-primary pt-5 pb-4 px-4">
              <div
                className="d-inline-flex align-items-center justify-content-center bg-primary rounded-circle position-absolute top-0 start-50 translate-middle shadow"
                style={{ width: 100, height: 100 }}
              >
                <i className="fa fa-globe fa-3x text-white" />
              </div>
              <h5 className="mt-4">Choose A Destination</h5>
              <hr className="w-25 mx-auto bg-primary mb-1" />
              <hr className="w-50 mx-auto bg-primary mt-0" />
              <div className="mt-3">
                <img
                  src="assets/img/process/destination.png"
                  alt="Choose Destination"
                  className="img-fluid rounded"
                  style={{ height: "210px", objectFit: "cover", width: "100%" }}
                />
              </div>
              <p className="mt-3 mb-0">
              Click <a href="/booknow" className="text-primary">Book Now</a> to go to the booking page, then select your trip type, pickup, destination, and number of persons, and hit "Search Options".
              </p>
            </div>
          </div>

          {/* Step 2 */}
          <div
            className="col-lg-4 col-sm-6 text-center pt-4 wow fadeInUp"
            data-wow-delay="0.3s"
          >
            <div className="position-relative border border-primary pt-5 pb-4 px-4">
              <div
                className="d-inline-flex align-items-center justify-content-center bg-primary rounded-circle position-absolute top-0 start-50 translate-middle shadow"
                style={{ width: 100, height: 100 }}
              >
                <i className="fa fa-car fa-3x text-white" />
              </div>
              <h5 className="mt-4">Select Your Vehicle</h5>
              <hr className="w-25 mx-auto bg-primary mb-1" />
              <hr className="w-50 mx-auto bg-primary mt-0" />
              <div className="mt-3">
                <img
                  src="assets/img/process/vehicle.png"
                  alt="Select Vehicle"
                  className="img-fluid rounded"
                  style={{ height: "210px", objectFit: "cover", width: "100%" }}
                />
              </div>
              <p className="mt-3 mb-0">
              Choose a suitable vehicle, verify your contact information, and click Confirm Booking to send your booking details to our team.
              </p>
            </div>
          </div>

          {/* Step 3 */}
          <div
            className="col-lg-4 col-sm-6 text-center pt-4 wow fadeInUp"
            data-wow-delay="0.5s"
          >
            <div className="position-relative border border-primary pt-5 pb-4 px-4">
              <div
                className="d-inline-flex align-items-center justify-content-center bg-primary rounded-circle position-absolute top-0 start-50 translate-middle shadow"
                style={{ width: 100, height: 100 }}
              >
                <i className="fa fa-qrcode fa-3x text-white" />
              </div>
              <h5 className="mt-4">Confirm & Pay</h5>
              <hr className="w-25 mx-auto bg-primary mb-1" />
              <hr className="w-50 mx-auto bg-primary mt-0" />
              <div className="mt-3">
                <img
                  src="assets/img/process/qrcode.jpeg"
                  alt="QR Code"
                  className="img-fluid rounded"
                  style={{ height: "233px", objectFit: "cover", width: "100%" }}
                />
              </div>
              <p className="mt-3 mb-0">
                After confirmation, pay online or offline. Use the QR code above for easy payment.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Process;